import React from "react";
import { FaEdit, FaPhone } from "react-icons/fa";
import { Card } from "../UI/DesignStandards";
import { PrimaryButton, SecondaryButton } from "../UI/DesignStandards/Buttons";
import { PhoneDisplay } from "../UI/DesignStandards/Display";

const PhoneSection = ({
  phone,
  editingPhone,
  loading,
  error,
  onEdit,
  onSave,
  onCancel,
  onChange,
}) => {
  return (
    <Card className="mb-0" aria-labelledby="phone-heading">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div
            className="w-10 h-10 bg-brand-cream rounded-lg flex items-center justify-center"
            aria-hidden="true"
          >
            <FaPhone className="h-5 w-5 text-brand-muted" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-3 gap-2">
            <h3 id="phone-heading" className="heading-display text-lg">
              Phone Number
            </h3>
            {!editingPhone ? (
              <SecondaryButton
                onClick={onEdit}
                icon={FaEdit}
                className="!px-3 !py-2 text-sm"
                aria-label="Edit phone number"
              >
                Edit
              </SecondaryButton>
            ) : (
              <div className="flex gap-2">
                <PrimaryButton
                  onClick={onSave}
                  disabled={loading}
                  loading={loading}
                  loadingText="Saving..."
                  aria-label={
                    loading
                      ? "Saving phone number"
                      : "Save phone number changes"
                  }
                >
                  Save
                </PrimaryButton>
                <SecondaryButton
                  onClick={onCancel}
                  className="!px-3 !py-2 text-sm"
                  aria-label="Cancel phone number changes"
                >
                  Cancel
                </SecondaryButton>
              </div>
            )}
          </div>

          {!editingPhone ? (
            <div className="p-3 card-inset">
              <p className="text-brand-charcoal font-medium">
                {phone ? (
                  <PhoneDisplay phone={phone} />
                ) : (
                  <span className="text-brand-muted italic">Not set</span>
                )}
              </p>
            </div>
          ) : (
            <div className="mt-3">
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-brand-charcoal mb-2"
              >
                Phone Number
              </label>
              <div className="relative">
                <div
                  className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none z-10"
                  aria-hidden="true"
                >
                  <FaPhone className="h-5 w-5 text-brand-muted" />
                </div>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={phone}
                  onChange={onChange}
                  maxLength="10"
                  className={`block w-full pl-12 px-4 py-3 border rounded-lg bg-white text-brand-charcoal focus:outline-none focus:ring-2 ${
                    error
                      ? "border-red-300 focus:ring-red-500"
                      : "border-brand-charcoal/20 focus:ring-brand-gold-ink"
                  }`}
                  placeholder="Enter phone number"
                  aria-describedby={error ? "phone-error" : "phone-help"}
                  aria-invalid={error ? "true" : "false"}
                />
              </div>
              {error && (
                <p
                  id="phone-error"
                  className="mt-1 text-sm text-red-600"
                  role="alert"
                >
                  {error}
                </p>
              )}
              <p id="phone-help" className="mt-1 text-sm text-brand-muted">
                Enter your 10-digit phone number
              </p>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default PhoneSection;
